import { authenticatedFetch } from '../../../api/utils/request';

export default async function getUserStatusCatalog(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener el catálogo de estados de usuario');
    return await authenticatedFetch('/admin-setup/user-status', onError);
}
